export var BugStatus = /*#__PURE__*/ function(BugStatus) {
    BugStatus["OPEN"] = "Open";
    BugStatus["IN_PROGRESS"] = "In Progress";
    BugStatus["IN_REVIEW"] = "In Review";
    BugStatus["RESOLVED"] = "Resolved";
    BugStatus["CLOSED"] = "Closed";
    BugStatus["REOPENED"] = "Reopened";
    BugStatus["BLOCKED"] = "Blocked";
    BugStatus["WONT_FIX"] = "Won't Fix";
    BugStatus["DUPLICATE"] = "Duplicate";
    BugStatus["CANNOT_REPRODUCE"] = "Cannot Reproduce";
    return BugStatus;
}({});
